var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoneOfThese = function SvgNoneOfThese(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9987 18.0371H22.838C20.667 18.0371 18.8917 19.771 18.843 21.9414C18.4223 40.6818 18.4551 52.7003 18.8508 71.4572C18.8961 73.6034 20.6337 75.3319 22.7801 75.3669C38.3327 75.6203 48.3971 75.6343 63.4795 75.3734C65.6584 75.3357 67.407 73.5568 67.407 71.3776V66.8705M55.3451 18.0371H62.9769C65.1479 18.0371 66.9214 19.7704 66.9928 21.9403C67.2925 31.0379 67.7296 37.1918 67.407 47.2176",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.082 45.5508V54.8241",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7314 45.5977V56.7896",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8784 25.9082C25.6885 39.6796 26.1948 46.4639 30.4092 59.2826",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9551 23.6328H25.5407C26.2668 41.3323 26.5503 51.5213 33.3769 66.6717C48.2675 66.8536 56.6028 66.6192 71.4902 65.5874C64.622 50.4134 60.9522 41.7069 61.3231 23.6328H54.8422",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7673 6.76364C50.4954 7.12942 51.6345 8.65804 51.2367 10.3014L49.7374 16.5356H55.1318L53.5876 27.8272H32.1453L30.3155 16.5356H35.8554L34.3659 10.463C33.9681 8.8196 34.8267 7.03709 36.9782 6.76364C36.9782 6.76364 40.7141 6.56258 43.9207 6.56263C47.1273 6.56268 48.7673 6.76364 48.7673 6.76364Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7207 46.7987L41.7581 54.1072C47.9389 47.038 51.2187 44 56.8704 39.4902",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4434 10.4062C43.6028 10.2809 41.7637 10.2816 38.0033 10.4062L38.8737 14.5154C38.9716 14.9776 39.3796 15.3082 39.852 15.3082H45.5549C46.0238 15.3082 46.4298 14.9823 46.5312 14.5244L47.4434 10.4062Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6572 24.4603C44.0021 24.4602 43.2189 24.4486 42.5005 24.4602C41.7821 24.4718 41.5221 24.4603 40.9021 24.4603",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4893 66.5722V69.7935C61.4893 69.7935 50.6366 70.3166 43.5595 70.4319C36.4824 70.5472 25.5629 69.7935 25.5629 69.7935L23.975 25.6836L25.5629 25.6836",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 5.63183,
    y2: -1,
    transform: "matrix(0.111735 0.993738 0.993738 -0.111735 30.3154 17.8652)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoneOfThese);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "none-of-these.879d4ffbb27ea26809a011e1fbb83acd.svg";